import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { AuthLoginForm } from 'forms';
import { FormWrapper, TopBorderPaper } from 'components';

export const AuthLoginPage = () => {
  return (
    <Box sx={{ paddingX: 2, paddingTop: 3, paddingBottom: 8 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', padding: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 400 }}>
        <Box sx={{ width: '100%', maxWidth: (theme) => theme.breakpoints.values.sm, position: 'relative' }}>
          <TopBorderPaper>
            <FormWrapper>
              <Typography variant="h5" sx={{ marginBottom: 1 }}>
                Sign in to get started
              </Typography>

              <Typography color="textSecondary" variant="body2" sx={{ lineHeight: 1.5, marginBottom: 6 }}>
                Login to your account below.
              </Typography>

              <AuthLoginForm />
            </FormWrapper>
          </TopBorderPaper>
        </Box>
      </Box>
    </Box>
  );
};
